/**
 * Matching rules and URL state for the Shop All diet & allergen filters
 * (docs/superpowers/specs/2026-09-30-dietary-allergen-filters-design.md).
 *
 * Pure and DOM-free so it's require()-able in node:test, mirroring
 * assets/delivery-week-preview.js. assets/dietary-filter.js owns every
 * browser-coupled bit: reading the checkboxes, the cards' data-diet /
 * data-allergens attributes, and window.location.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.StockedDietaryFilterMatch = api;
})(typeof self !== 'undefined' ? self : this, function () {
  // One query param per chip kind. These are also the checkbox `name`s in
  // snippets/dietary-filter.liquid, so the form and the URL share one vocabulary.
  var KEYS = ['diet', 'exclude', 'allergen'];

  function emptyState() {
    return { diet: [], exclude: [], allergen: [] };
  }

  // " Nuts, milk,,EGG " -> ['nuts', 'milk', 'egg']. Metaobject handles are always
  // lowercase, so lowercasing lets a hand-typed URL still match.
  function splitHandles(raw) {
    if (typeof raw !== 'string') return [];
    return raw
      .split(',')
      .map(function (h) { return h.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function hasAny(handles, selected) {
    for (var i = 0; i < selected.length; i += 1) {
      if (handles.indexOf(selected[i]) !== -1) return true;
    }
    return false;
  }

  // card: { diet: string[], allergens: string[] } -- metaobject handles.
  // Include chips (diet) OR within their group and hide untagged products: we
  // can't present a dish as vegetarian without knowing it is. Exclude chips
  // (exclude, allergen) hide only a POSITIVE tag, so an untagged product stays
  // visible -- the agreed fail-open rule (spec §4.2). Groups combine with AND.
  function isVisible(card, state) {
    var diet = (card && card.diet) || [];
    var allergens = (card && card.allergens) || [];
    if (state.diet.length && !hasAny(diet, state.diet)) return false;
    if (hasAny(diet, state.exclude)) return false;
    if (hasAny(allergens, state.allergen)) return false;
    return true;
  }

  function activeCount(state) {
    return state.diet.length + state.exclude.length + state.allergen.length;
  }

  // known: the chips actually rendered on the page, per param. A handle that is
  // unknown, sits under the wrong param, or repeats is dropped -- a stale or
  // hand-edited URL must never apply a filter the customer can't see or untick.
  function parseState(search, known) {
    var params = new URLSearchParams(search || '');
    var state = emptyState();
    KEYS.forEach(function (key) {
      var allowed = (known && known[key]) || [];
      splitHandles(params.get(key)).forEach(function (h) {
        if (allowed.indexOf(h) !== -1 && state[key].indexOf(h) === -1) state[key].push(h);
      });
    });
    return state;
  }

  // Returns the new search string ('' or '?...'). Every other param -- notably
  // the ?delivery_week= preview -- is left untouched. Commas are written
  // literally (URLSearchParams would encode them as %2C) so a shared link stays
  // readable; parseState() accepts either form.
  function writeState(search, state) {
    var params = new URLSearchParams(search || '');
    KEYS.forEach(function (key) {
      if (state[key].length) params.set(key, state[key].join(','));
      else params.delete(key);
    });
    var query = params.toString().replace(/%2C/gi, ',');
    return query ? '?' + query : '';
  }

  return {
    KEYS: KEYS,
    emptyState: emptyState,
    splitHandles: splitHandles,
    isVisible: isVisible,
    activeCount: activeCount,
    parseState: parseState,
    writeState: writeState,
  };
});
